import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { EnterpriseLockService } from '@core/service/enterprise-lock.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-enterprise-lock-overlay',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule, TranslateModule],
  template: `
    @if (isLocked) {
      <div class="lock-overlay">
        <div class="lock-content">
          <mat-icon class="lock-icon">lock</mat-icon>
          <h2>{{ 'ENTERPRISE_LOCK.TITLE' | translate }}</h2>
          <p>{{ 'ENTERPRISE_LOCK.MESSAGE' | translate }}</p>
          <mat-spinner diameter="40"></mat-spinner>
          @if (jobType) {
            <p class="lock-detail">
              {{ 'ENTERPRISE_LOCK.OPERATION' | translate }}: 
              {{ 'ENTERPRISE_LOCK.JOB_TYPES.' + jobType | translate }}
            </p>
          }
        </div>
      </div>
    }
  `,
  styles: [`
    .lock-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      backdrop-filter: blur(4px);
    }

    .lock-content {
      background: white;
      border-radius: 16px;
      padding: 48px;
      text-align: center;
      max-width: 480px;
      box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2);
    }

    :host-context(.dark) .lock-content,
    :host-context([data-theme="dark"]) .lock-content {
      background: #1e1e2d;
      color: #e0e0e0;
    }

    .lock-icon {
      font-size: 64px;
      width: 64px;
      height: 64px;
      color: #f59e0b;
      margin-bottom: 16px;
    }

    h2 {
      margin: 0 0 8px;
      font-size: 1.5rem;
      font-weight: 600;
    }

    p {
      margin: 0 0 24px;
      color: #666;
      font-size: 0.95rem;
    }

    :host-context(.dark) p,
    :host-context([data-theme="dark"]) p {
      color: #aaa;
    }

    mat-spinner {
      margin: 0 auto 16px;
    }

    .lock-detail {
      font-size: 0.85rem;
      color: #999;
      margin-bottom: 0;
    }
  `]
})
export class EnterpriseLockOverlayComponent implements OnInit, OnDestroy {
  isLocked = false;
  jobType: string | null = null;
  private subscription = new Subscription();

  constructor(private enterpriseLockService: EnterpriseLockService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.enterpriseLockService.locked$.subscribe((locked) => {
        this.isLocked = locked;
      })
    );

    this.subscription.add(
      this.enterpriseLockService.lockInfo$.subscribe((info) => {
        this.jobType = info?.jobType || null;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
